import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/timeline/index.js
// module id = 812
// module chunks = 0